<div class="slider-wrapper">
  <div class="icon-container" *ngIf="icon">
    <rr-icon [name]="icon"></rr-icon>
  </div>
  <div class="slider-container">
    <div class="label">{{label}}</div>
    <input type="range" min="0" max="100" [(ngModel)]="value" (input)="onChange()">
    <div class="range-text">
      <div>{{leftLabel}}</div>
      <div>{{rightLabel}}</div>
    </div>
  </div>
</div>